import * as React from 'preact/compat'
import cn from 'classnames'
import styles from '../../../css/game-search-modal.pcss.json'
import SVG from '../SVG'
import type { SeriesInfoInterface } from './types'

export default ({ series, add, selected }: {
  series: SeriesInfoInterface,
  selected?: boolean,
  add: (series: SeriesInfoInterface) => void
}) => {
  const buttonRef = React.useRef<HTMLButtonElement>(null)

  React.useEffect(() => {
    if (selected && buttonRef.current) {
      buttonRef.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [selected])

  const addSeries = (e: React.TargetedEvent<HTMLButtonElement>) => {
    e.preventDefault()
    add(series)
  }

  return <button type='button' onClick={addSeries} className={cn({
    [`${styles['game']}`]: true,
    [`${styles['game--selected']}`]: selected,
  })} ref={buttonRef}>
    <div className={styles['game__inner']}>
      <img alt='' src={series.square_poster} className={styles['game__image']} />
      <span class={styles['game__title']}>{series.name}</span>
      <span class={styles['game__date']}><SVG i='sg-new/gamepad' adaptive/> {series.games_count}</span>
    </div>
  </button>
}
